import {Component, EventEmitter, Output} from '@angular/core';
import {IdexService} from 'app/idex.service';

declare let $: any;

@Component({
   selector: 'app-sign-list',
   templateUrl: './sign-list.component.html',
   styleUrls: ['./sign-list.component.css']
})
export class SignListComponent {
   public documents: any;
   public signs: any;
   public isShow: any = [];
   @Output() pageListClick = new EventEmitter<any>();
   @Output() positionSignClick = new EventEmitter<any>();

   constructor(public service: IdexService) {}

   setSignList(index: any, typeName: any) {
      const doc = this.documents[index];
      this.signs = doc.signPageList;
   }

   onClickHideShowSignList(event) {
      const target = event.target || event.srcElement || event.currentTarget;
      if (target.attributes.id) {
         const id = target.attributes.id.value;
         if (id === 'header-sign') {
            $($(target).children()).slideToggle();
         } else if (id === 'submenu-sign') {
            $($(target).children()).slideToggle();
         }
      }
   }

   onClickPageList(pageNo) {
      this.pageListClick.emit(pageNo);
   }

   onClickPositionSign(pageNo, pos, index, signerEmail, signerReassignEmail) {
      this.positionSignClick.emit({pageNo: pageNo, positionSign: pos, index: pos.order, signerEmail: signerEmail, signerReassignEmail: signerReassignEmail});
   }
}
